import { addCyPrefixToIDs } from 'moet-test-utils/cypress/utils';

const cyPrefix = 'containers_pre_assessment_products_container';

const ids = {
  ...addCyPrefixToIDs(cyPrefix, {
    BTN_BACK: 'BTN_BACK',
    BTN_SUBMIT: 'BTN_SUBMIT',
  }),
  SELECT_COUNTRY: country => `SELECT_PRODUCTS_${country}`,
  SELECT_PRODUCT: (country, product) => `SELECT_PRODUCTS_${country}_${product}`,
  SELECTED_PRODUCT_BATCH: country => `SELECTED_PRODUCT_BATCH_${country}`,
};

export const CY_PRE_ASSESSMENT_PRODUCTS_CONTAINER_IDS = ids;
